// src/components/Meta.js
import React from 'react';
import { Helmet } from 'react-helmet';

const Meta = () => {
    return (
        <Helmet>
            <title>IM CHESS Academy</title>
            <meta name="description" content="The upcoming era of champions in the growing chess world. Chase & Checkmate" />
            <meta name="keywords" content="Learn Chess" />
            <meta name="keywords" content="Chess classes" />

            {/* Open Graph tags for social media */}
            <meta property="og:title" content="IM CHESS Academy" />
            <meta property="og:description" content="The upcoming era of champions in the growing chess world. Chase & Checkmate" />
            <meta property="og:image" content="%PUBLIC_URL%/favicon.png" />
            {/* <meta property="og:url" content="http://example.com/" /> */}
            <meta property="og:type" content="chess website" />

            {/* Twitter Card tags for Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="IM CHESS Academy" />
            <meta name="twitter:description" content="The upcoming era of champions in the growing chess world. Chase & Checkmate" />
            <meta name="twitter:image" content="https://mlpr3v7xng2n.i.optimole.com/cb:C7ow.1822c/w:1600/h:1073/q:mauto/f:best/ig:avif/https://www.batterseachessclub.org.uk/wp-content/uploads/2020/11/pasted-image-0.jpg" />
        </Helmet>
    );
};

export default Meta;